import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { PropertyGroupApiData } from "../propertyGroupModal";

interface PropertiesSectionProps {
  formData: PropertyGroupApiData;
  onSectionChange: (field: "title" | "description", value: string) => void;
  quillModules: any;
  quillFormats: string[];
}

const PropertiesSection: React.FC<PropertiesSectionProps> = ({
  formData,
  onSectionChange,
  quillModules,
  quillFormats,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Properties Section Title
        </label>
        <input
          type="text"
          value={formData.style.properties_section.title}
          onChange={(e) =>
            onSectionChange("title", e.target.value)
          }
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., Featured Properties"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Properties Section Description
        </label>
        <ReactQuill
          theme="snow"
          value={formData.style.properties_section.description}
          onChange={(value) =>
            onSectionChange("description", value)
          }
          modules={quillModules}
          formats={quillFormats}
          placeholder="Description for properties section"
        />
      </div>
    </div>
  );
};

export default PropertiesSection;

